import { ReactNode, WheelEvent } from "react";

import Icon from "../Icon";

import { ToggleDirection } from "./constants";
import * as styledElements from "./NumberInputStyles";

const NumberInputWrapper = ({
  children,
  disabled,
  handleToggle,
  isSmallSize = false,
}: {
  children: ReactNode;
  disabled?: boolean;
  handleToggle: (direction: ToggleDirection) => void;
  isSmallSize?: boolean;
}) => {
  const preventScrollingToUpdateInput = (event: WheelEvent) => {
    if (event.target instanceof HTMLElement) {
      event.target.blur();
    }
  };

  return (
    <styledElements.InputField onWheel={preventScrollingToUpdateInput}>
      {children}
      <styledElements.ToggleArea isSmallSize={isSmallSize}>
        <styledElements.Toggle
          onClick={() => !disabled && handleToggle(ToggleDirection.UP)}
          disabled={disabled}
        >
          <Icon src="/icons/retract.svg" alt="add-boards" iconDimension={6} />
        </styledElements.Toggle>
        <styledElements.Toggle
          onClick={() => !disabled && handleToggle(ToggleDirection.DOWN)}
          disabled={disabled}
        >
          <Icon src="/icons/expand.svg" alt="add-boards" iconDimension={6} />
        </styledElements.Toggle>
      </styledElements.ToggleArea>
    </styledElements.InputField>
  );
};

export default NumberInputWrapper;
